import { Actions } from './users.actions'
import { fromJS } from 'immutable'
import * as UsersTypes from './users.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    pagination: {
      page_size: 20,
      page: 1,
      sort: '',
      order_by: '',
    },
    filters: [],
    total: 0,
    filtered: 0,
  },
  roles: {
    isLoading: false,
    data: [],
  },
  createUser: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateUser: {
    isLoading: false,
    isPasswordUpdating: false,
    validationErrors: {},
    data: {},
  },
  userDetails: {
    isLoading: false,
    data: {},
  },
})

export function usersReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case UsersTypes.UPDATE_USER_REQUEST: {
      return state.setIn(['updateUser', 'isLoading'], true)
    }

    case UsersTypes.UPDATE_USER_SUCCESS: {
      return state.setIn(['updateUser', 'isLoading'], false)
    }

    case UsersTypes.UPDATE_USER_FAILURE: {
      return state.setIn(['updateUser', 'isLoading'], false)
    }

    case UsersTypes.UPDATE_USER_PASSWORD_REQUEST: {
      return state.setIn(['updateUser', 'isPasswordUpdating'], true)
    }

    case UsersTypes.UPDATE_USER_PASSWORD_SUCCESS: {
      return state.setIn(['updateUser', 'isPasswordUpdating'], false)
    }

    case UsersTypes.UPDATE_USER_PASSWORD_FAILURE: {
      return state.setIn(['updateUser', 'isPasswordUpdating'], false)
    }

    case UsersTypes.CREATE_USER_REQUEST: {
      return state.setIn(['createUser', 'isLoading'], true)
    }

    case UsersTypes.CREATE_USER_SUCCESS: {
      return state.setIn(['createUser', 'isLoading'], false)
    }

    case UsersTypes.CREATE_USER_FAILURE: {
      return state.setIn(['createUser', 'isLoading'], false)
    }

    case UsersTypes.DELETE_USER_REQUEST: {
      return state
    }

    case UsersTypes.DELETE_USER_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case UsersTypes.DELETE_USER_FAILURE: {
      return state
    }

    case UsersTypes.FETCH_ROLES_REQUEST: {
      return state.setIn(['roles', 'isLoading'], true)
    }

    case UsersTypes.FETCH_ROLES_SUCCESS: {
      return state
        .setIn(['roles', 'isLoading'], false)
        .setIn(['roles', 'data'], fromJS(action.payload.roles))
    }

    case UsersTypes.FETCH_ROLES_FAILURE: {
      return state.setIn(['roles', 'isLoading'], false)
    }

    case UsersTypes.FETCH_USERS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case UsersTypes.FETCH_USERS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], action.total)
        .setIn(['list', 'filtered'], action.filtered)
    }

    case UsersTypes.FETCH_USERS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case UsersTypes.FETCH_USER_REQUEST: {
      return state.setIn([action.property, 'isLoading'], true)
    }

    case UsersTypes.FETCH_USER_SUCCESS: {
      return state
        .setIn([action.property, 'isLoading'], false)
        .setIn([action.property, 'data'], fromJS(action.payload))
    }

    case UsersTypes.FETCH_USER_FAILURE: {
      return state.setIn([action.property, 'isLoading'], false)
    }

    case UsersTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case UsersTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
